
const FormFieldCandidate = ({input, label, type, meta:{touched, error}}) => {
    return (
        <div className="form-group">
            <label htmlFor={input.name} className="active">{label}</label>
            <input {...input} id={input.name} type={type} className="validate form-control form-control-user" />
            <span className="helper-text text-danger small" data-error="wrong">{touched && error}</span>
        </div>
    );
}; 
export default FormFieldCandidate;